/*eslint no-unused-vars: "off"*/
export const Getters = {
    isCompanyLoaded(state, getters) {
        return (getters['currentCompany/isLoadedCompanyInfo'])
    },
    isStatewide(state, getters) {
        return (getters['currentCompany/isStatewide'])
    },
    toastShowCount: state => {
      return state.toastShowCount
    },
    toastSettings: state => {
      return {
          toastContent: state.toastContent,
          toastOptions: state.toastOptions
      }
    },
    appLoadStatus: state => {
      return state.isLoadedApp
    },
    makes: (state,getters) => {
        if (getters.isStatewide){
            return state.statewideMakes
        }
        return state.makes
    },
    truckMakes: state => {
        return state.truckMakes
    },
    isStartedReinstate: state => {
      return state.isStartedReinstate
    },
    quoteOpenDaysForRequest: state => {
      return state.quoteOpenDaysForRequest;
    },
    addressStates: state => {
        return state.addressStates;
    },
    addressCountries: state => {
        return state.addressCountries;
    },
    paymentTypes: state => {
        return state.paymentTypes;
    },
    vehicleTransmissions: state => {
        return state.vehicleTransmissions;
    },
    getActiveMainTemplateClass: (state, getters) => {
        let cssClass = 'theme-home';
        if (getters['currentUser/isUserTypeRepairer']) {
            cssClass = 'theme-repairer';
        } else if (getters['currentUser/isUserTypeSupplier']) {
            cssClass = 'theme-supplier';
        }
        if (getters['currentCompany/isBranding']) {
            cssClass += ' ' + getters['currentCompany/getBrandingClassName'];
        }
        return cssClass;
    },
    stockOptions(state) {
        return state.stockOptions
    },
    getSupplierBusinessTypes: state=>{
        return state.supplierBusinessTypes
    }
};
